/**
 * risktypereducer.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../../actions/actiontypes';
import lodash from 'lodash';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import {uuid as uuidv4} from '../../util/uuid';
import _ from 'lodash';

export default function riskTypeReducer(state = initialstate.riskTypes, action) {
	switch (action.type) {
		case types.GET_RISK_TYPES:
			return risksGroupedByRiskTypes(action.response);
		case types.CREATE_ASSERTION_RISK_RELATION:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				if (action.reducerModel && action.reducerModel.length > 0) {
					let updatedState = _.cloneDeep(state);
					action.reducerModel.forEach((assertion) => {
						let assertionObject = action.assertions[assertion.assertionId];
						const updatedAssertion = {...assertionObject};
						updatedAssertion.hasRiskAssociated = true;
						updatedAssertion.account = {
							accountName: assertion.account.accountName,
							hasEstimate: assertion.account.hasEstimate,
							id: assertion.account.id
						};
						let updatedRiskType = updatedState?.data?.find((x) => x.id === action.risk.riskTypeId);

						if (updatedRiskType) {
							let updatedRisk = updatedRiskType.risks?.find((x) => x.id === action.risk.id);

							if (updatedRisk) {
								updatedRisk.assertions = [...updatedRisk.assertions, updatedAssertion];
								let updatedAssertionsGroupedByRiskTypes = [...updatedRisk.assertionsGroupedByRiskTypes];

								let index = updatedAssertionsGroupedByRiskTypes.findIndex((x) => x.account.key === assertion.account.id.toString());
								if (index >= 0) {
									updatedAssertionsGroupedByRiskTypes[index].assertionResults.push(updatedAssertion);
								} else {
									updatedAssertionsGroupedByRiskTypes.push({
										account: {
											key: assertion.account.id.toString(),
											hash: action.hash
										},
										assertionResults: [updatedAssertion]
									});
								}

								updatedRisk.assertionsGroupedByRiskTypes = [...updatedAssertionsGroupedByRiskTypes];
							}
						}
					});
					return {...updatedState, update: false};
				}
			}

			return state;
		case types.DELETE_ASSERTION_RISK_RELATION:
			let newState = _.cloneDeep(state);

			let riskType = newState?.data?.find((x) => x.id === action.risk.riskTypeId);

			if (riskType) {
				let risk = riskType.risks?.find((x) => x.id === action.risk.id);

				if (risk) {
					//Delete all
					risk.assertions = risk.assertions.filter((x) => !action.assertionIds.includes(x.id));
					let position = risk.assertionsGroupedByRiskTypes.findIndex((x) => x.account.hash === action.hash);
					if (position >= 0) {
						let newValues = risk.assertionsGroupedByRiskTypes[position].assertionResults.filter((x) => !action.assertionIds.includes(x.id));
						risk.assertionsGroupedByRiskTypes[position].assertionResults = newValues;
						if (newValues.length === 0) {
							risk.assertionsGroupedByRiskTypes = risk.assertionsGroupedByRiskTypes.filter((x) => x.account.hash !== action.hash);
						}
					}
				}
			}

			return newState;
		default:
			return state;
	}
}

export function formatRiskTypes(riskTypes) {
	let formattedRiskTypes = {};
	if (riskTypes && riskTypes.data && riskTypes.data.length > 0) {
		formattedRiskTypes = riskTypes.data;
	}
	return formattedRiskTypes;
}

const risksGroupedByRiskTypes = (state) => {
	const result = state.data?.map((element) => {
		return {
			...element,
			risks: element.risks?.map((r) => {
				return {
					...r,
					assertionsGroupedByRiskTypes: lodash
						.chain(r.assertions)
						.groupBy('account.id')
						.orderBy((group) => {
							return group[0].account.accountName;
						})
						.map((value) => {
							return {
								account: {
									key: value[0].account.id.toString(),
									hash: uuidv4()
								},
								assertionResults: value
							};
						})
						.value()
				};
			})
		};
	});

	return (
		{
			...state,
			data: result
		} || state
	);
};
